export default {
  'dept.title': '区域名称',
  'dept.btn.add': '新增区域',
  'dept.btn.addSubsidiary': '新增子区域',
  'dept.btn.edit': '编辑区域',
  'dept.btn.del': '删除区域',
  'dept.input.dept.placeholder': '请输入区域名称',
};
